import React, { Component } from 'react';
import ConditionedComponent from 'components/ConditionedComponent.js';
import Guilds from './Guilds.js';
import LinkedMembers from './LinkedMembers.js';
import NewMemberRequests from 'components/guilds/NewMemberRequests.js';

class LinksComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedGuild: undefined
        };
    }

    onClickGuild(guildId) {
        if (guildId === this.state.selectedGuild) {
            this.setState({selectedGuild: undefined});
        } else {
            this.setState({selectedGuild: guildId});
        }
    }

    render() {
        return (
            <div className="links-view">
              <LinkedMembers
                selectedGuild={this.state.selectedGuild}
                ethereum={this.props.ethereum}/>
              <Guilds
                selectedGuild={this.state.selectedGuild}
                onClickGuild={(guild) => this.onClickGuild(guild)}
                ethereum={this.props.ethereum}/>
              <NewMemberRequests ethereum={this.props.ethereum}/>
           </div>
        );
    }
}

export default LinksComponent;
